export default __webpack_public_path__ + "static/media/scan2pay_banner.2610d212.png";